import React, { useEffect, useState } from "react";
import EditIcon from "../../assets/icons/edit.svg";
import DeleteIcon from "../../assets/icons/delete.svg";
import MenuIcon from "../../assets/icons/menu.svg";

import Sidebar from "../../components/Sidebar/Sidebar";
import { userService } from "../../services/user.service";

import "./UsersAdmin.css";
import "../../utils/animate.css";
import ModalAddUser from "../../components/ModalAddUser/ModalAddUser";
import ModalEditUser from "../../components/ModalEditUser/ModalEditUser";
import ModalConfirm from "../../components/ModalConfirm/ModalConfirm";
import { closeModal, showModal } from "../../utils/functions/modal";

const UsersAdmin = () => {
  const [users, setUsers] = useState(undefined);
  const [userEdit, setUserEdit] = useState();
  const [idUser, setIdUser] = useState();
  const [message, setMessage] = useState(undefined);

  const getAllUsers = async () => {
    const response = await userService.getAllUsers();
    if (response.status === 200) {
      setUsers(response.data.usuarios);
    }
  };

  useEffect(() => {
    getAllUsers();
  }, []);

  const showSidebar = () => {
    document
      .querySelector(".container-sidebar")
      ?.classList.add("show-sidebar");
  };

  const showModalEditUser = (user) => {
    setUserEdit(user);
    showModal(".container-modal-edit-user");
  };

  const showModalDelete = (user) => {
    showModal(".container-modal-confirm");

    setIdUser(user.id);
    setMessage({
      description: `¿Estás seguro de eliminar al usuario "${user.username}"?`,
      status: 300,
      action: deleteUser,
    });
  };

  const deleteUser = async (id) => {
    setMessage({
      description: "Eliminando usuario...",
      status: 1000,
    });
    const response = await userService.deleteUser(id);
    setTimeout(async () => {
      setMessage({
        description: response.data.message,
        status: response.data.status,
      });
      if (response.data.status === 200) {
        await getAllUsers();
      }
      setTimeout(() => {
        closeModal(".container-modal-confirm");
      }, 2000);
    }, 1000);
  };

  return (
    <>
      <ModalConfirm
        message={message}
        actionConfirm={message?.action}
        idSale={idUser}
      />

      <ModalEditUser
        setMessage={setMessage}
        user={userEdit}
        onSuccess={getAllUsers}
      />
      <ModalAddUser setMessage={setMessage} onSuccess={getAllUsers} />

      <div className="container-users-admin">
        <Sidebar />
        <div className="users-admin">
          <div className="head-admin">
            <button className="btn-menu" onClick={() => showSidebar()}>
              <img src={MenuIcon} alt="" />
            </button>
            <h1 className="animate fadeIn">USUARIOS</h1>
            <button
              onClick={() => showModal(".container-modal-add-user")}
              className="btn-add-product animate fadeIn"
            >
              AGREGAR
            </button>
          </div>

          <div className="table-users">
            {users && users.length > 0 && (
              <table cellSpacing="0">
                <thead className="head-table animate fadeIn">
                  <tr>
                    <th>N°</th>
                    <th>Usuario</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {users.map((user, key) => (
                    <tr
                      key={user.id}
                      style={{ animationDelay: `${Math.min(key, 8) * 0.06}s` }}
                    >
                      <td>{user.id}</td>
                      <td>
                        {user.username}
                        {user.esVosMismo && <span className="you-badge">VOS</span>}
                      </td>
                      <td>
                        <button
                          className="action"
                          onClick={() => showModalEditUser(user)}
                        >
                          <img src={EditIcon} alt="" />
                        </button>
                        {!user.esVosMismo && (
                          <button
                            className="action"
                            onClick={() => showModalDelete(user)}
                          >
                            <img src={DeleteIcon} alt="" />
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
            {users && users.length === 0 && (
              <div className="empty-users">
                <p>No hay usuarios cargados</p>
              </div>
            )}
            {users === undefined && <div className="empty-users"></div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default UsersAdmin;
